export const checksums = {
  "articles": "v3.5.0--m-9hzZ67HN6bsh05BbGr7Y41quPHu9z_xDO1mPFbBHw"
}
export const checksumsStructure = {
  "articles": "R6uJ_6gPIQOsFeeZG1lQKjqzAGDeF_KW6wJQnFZtq0o"
}

export const tables = {
  "articles": "_content_articles",
  "info": "_content_info"
}

export default {
  "articles": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "body": "json",
      "category": "json",
      "date": "string",
      "description": "string",
      "draft": "boolean",
      "extension": "string",
      "image": "json",
      "meta": "json",
      "navigation": "json",
      "path": "string",
      "schedule": "json",
      "seo": "json",
      "source": "string",
      "stem": "string",
      "tag": "json"
    }
  },
  "info": {
    "type": "data",
    "fields": {}
  }
}